import { CartLinesUpdateEvent } from '@shopify/events';

const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const FREE_SHIPPING = 3000;
const money = (cents) =>
  new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(cents / 100);

/* Añade varias líneas y deja que Horizon abra y repinte su carrito lateral */
async function addLines(lines, source) {
  const sections = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lines.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity })),
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines, sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: cart.item_count, sections: res.ok ? data.sections : undefined, source: 'patamora', didError: !res.ok },
    });
    if (!res.ok) throw new Error(data.description || data.message || 'No se ha podido añadir al carrito.');
  } catch (error) {
    deferred.resolve({ detail: { didError: true, source: 'patamora' } });
    throw error;
  }
}

/* ---------- Completa tu pedido ---------- */

function initBundle(box) {
  const main = box.querySelector('[data-pm-bundle-main]');
  const totalEl = box.querySelector('[data-pm-bundle-total]');
  const shipEl = box.querySelector('[data-pm-bundle-ship]');
  const label = box.querySelector('[data-pm-bundle-label]');
  const button = box.querySelector('[data-pm-bundle-add]');
  const errorEl = box.querySelector('[data-pm-error]');

  const extras = () => [...box.querySelectorAll('.pm-bundle__item:not(.is-main)')];

  const syncExtra = (item) => {
    const select = item.querySelector('.pm-bundle__variant');
    const check = item.querySelector('.pm-bundle__check');
    if (!select) return;
    const opt = select.selectedOptions[0];
    check.value = opt.value;
    check.dataset.price = opt.dataset.price;
  };

  const update = () => {
    const chosen = extras().filter((i) => i.querySelector('.pm-bundle__check').checked);
    const total = chosen.reduce((sum, i) => sum + Number(i.querySelector('.pm-bundle__check').dataset.price), Number(main.dataset.price));
    const count = chosen.length + 1;
    totalEl.textContent = money(total);
    shipEl.textContent = total >= FREE_SHIPPING ? ' · envío gratis' : ` · te faltan ${money(FREE_SHIPPING - total)} para el envío gratis`;
    label.textContent = count === 1 ? 'Añadir al carrito' : `Añadir los ${count} al carrito`;
    box.querySelectorAll('.pm-bundle__item').forEach((i) => i.classList.toggle('is-on', i.querySelector('.pm-bundle__check').checked));
  };

  /* La variante principal es la que esté elegida en el formulario del producto */
  const mainVariantId = () => {
    const input = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    return (input && input.value) || main.value;
  };

  document.addEventListener('variant:update', (event) => {
    const v = event.detail && event.detail.resource;
    if (!v || !v.id) return;
    main.value = v.id;
    if (typeof v.price === 'number') {
      main.dataset.price = v.price;
      const priceEl = box.querySelector('[data-pm-bundle-main-price]');
      if (priceEl) priceEl.textContent = money(v.price);
    }
    const variantEl = box.querySelector('[data-pm-bundle-main-variant]');
    if (variantEl && v.title && v.title !== 'Default Title') variantEl.textContent = v.title;
    update();
  });

  box.addEventListener('change', (event) => {
    const item = event.target.closest('.pm-bundle__item');
    if (!item) return;
    if (event.target.matches('.pm-bundle__variant')) {
      syncExtra(item);
      item.querySelector('.pm-bundle__check').checked = true;
    }
    update();
  });

  button.addEventListener('click', async () => {
    errorEl.textContent = '';
    const lines = [{ id: Number(mainVariantId()), quantity: 1 }];
    extras().forEach((i) => {
      const check = i.querySelector('.pm-bundle__check');
      if (check.checked) lines.push({ id: Number(check.value), quantity: 1 });
    });
    button.setAttribute('aria-busy', 'true');
    try {
      await addLines(lines, button);
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 2200);
    } catch (error) {
      errorEl.textContent = error.message;
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  extras().forEach(syncExtra);
  update();
}

document.querySelectorAll('[data-pm-bundle]').forEach(initBundle);

/* ---------- Hero: aviso de "desliza" sobre el sofá ---------- */

document.querySelectorAll('[data-pm-scene] .pm-scene').forEach((scene) => {
  if (scene.querySelector('.pm-swipe')) return;
  const touch = window.matchMedia('(hover: none), (pointer: coarse)').matches;
  const hint = document.createElement('div');
  hint.className = 'pm-swipe';
  hint.setAttribute('aria-hidden', 'true');
  hint.innerHTML = `
    <span class="pm-swipe__hand">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V11"/><path d="M12 10.5v-1a1.5 1.5 0 0 1 3 0v1.5"/><path d="M15 11a1.5 1.5 0 0 1 3 0v3.5A6.5 6.5 0 0 1 11.5 21h-.6a6 6 0 0 1-4.6-2.2L3.6 15.5a1.6 1.6 0 0 1 2.4-2.1L9 16V11"/></svg>
    </span>
    <span class="pm-swipe__text">${touch ? 'Desliza para limpiar el sofá' : 'Haz scroll para limpiar el sofá'}</span>`;
  scene.appendChild(hint);
});

/* ---------- Tarjetas: al elegir color o talla se ve la foto y se añade esa variante ---------- */

const productCache = new Map();
function loadProduct(handle) {
  if (!productCache.has(handle)) {
    productCache.set(
      handle,
      fetch(`${root}products/${handle}.js`, { headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null))
    );
  }
  return productCache.get(handle);
}

document.addEventListener('change', async (event) => {
  const input = event.target.closest('input[data-pm-variant], select[data-pm-variant]');
  if (!input) return;
  const card = input.closest('.pm-pack, .pm-card');
  if (!card) return;
  /* Los desplegables no cuentan como "checked": el botón lee data-variant */
  const addButton = card.querySelector('[data-pm-add]');
  if (addButton && input.tagName === 'SELECT') addButton.dataset.variant = input.value;
  const link = card.querySelector('a[href*="/products/"]');
  const img = card.querySelector('.pm-pack__img--1, .pm-card__media img');
  if (!link || !img) return;
  const handle = new URL(link.href, location.origin).pathname.split('/products/')[1]?.split(/[/?#]/)[0];
  const product = handle && (await loadProduct(handle));
  const variant = product && product.variants.find((v) => String(v.id) === input.value);
  const src = variant && variant.featured_image && variant.featured_image.src;
  if (!src) return;
  const url = new URL(src, location.origin);
  url.searchParams.set('width', '600');
  img.srcset = '';
  img.src = url.toString();
  if (variant.featured_image.alt) img.alt = variant.featured_image.alt;
});
